"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="UserSettings.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxUserSettings object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxUserSettings = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxTimeSpan_1 = require("./HxTimeSpan");
var HxUserSettings = /** @class */ (function (_super) {
    __extends(HxUserSettings, _super);
    function HxUserSettings(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxUserSettings, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxUserSettings.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '15E0':
                        this.accountHandle = v;
                        break;
                    case '15E1':
                        this.autoReplyAutoDeclineFutureRequestsWhenOOF = v;
                        break;
                    case '15E2':
                        this.autoReplyCreateOOFEvent = v;
                        break;
                    case '15E3':
                        this.autoReplyDeclineAllEventsForScheduledOOF = v;
                        break;
                    case '15E4':
                        this.autoReplyDeclineEventsForScheduledOOF = v;
                        break;
                    case '15E5':
                        this.autoReplyDeclineMeetingMessage = v;
                        break;
                    case '15E6':
                        this.autoReplyDeclineMeetingMessageText = v;
                        break;
                    case '15E7':
                        this.autoReplyEndTime = new Date(v);
                        break;
                    case '15E8':
                        var autoReplyEventsToDeleteIDsCollectionValues = v;
                        this.autoReplyEventsToDeleteIDsCollection = new Array(autoReplyEventsToDeleteIDsCollectionValues.length);
                        for (var i = 0; i < autoReplyEventsToDeleteIDsCollectionValues.length; i++) {
                            this.autoReplyEventsToDeleteIDsCollection[i] = autoReplyEventsToDeleteIDsCollectionValues[i];
                        }
                        break;
                    case '15E9':
                        this.autoReplyExternalAudience = v;
                        break;
                    case '15EA':
                        this.autoReplyExternalMessage = v;
                        break;
                    case '15EB':
                        this.autoReplyExternalMessageText = v;
                        break;
                    case '15EC':
                        this.autoReplyInternalMessage = v;
                        break;
                    case '15ED':
                        this.autoReplyInternalMessageText = v;
                        break;
                    case '15EE':
                        this.autoReplyOOFEventSubject = v;
                        break;
                    case '15EF':
                        this.autoReplyStartTime = new Date(v);
                        break;
                    case '15F0':
                        this.autoReplyState = v;
                        break;
                    case '15F1':
                        this.calendarCurrentTimeZone = v;
                        break;
                    case '15F2':
                        this.calendarDefaultMeetingDurationMinutes = v;
                        break;
                    case '15F3':
                        this.calendarDefaultReminderTime = v;
                        break;
                    case '15F4':
                        this.calendarFirstWeekOfYear = v;
                        break;
                    case '15F5':
                        this.calendarLocalEventsEnabled = v;
                        break;
                    case '15F6':
                        this.calendarLocalEventsLocationId = new HxObjectID_1.default(v);
                        break;
                    case '15F7':
                        this.calendarRemindersEnabled = v;
                        break;
                    case '15F8':
                        this.calendarReminderSoundEnabled = v;
                        break;
                    case '15F9':
                        this.calendarShowWeekNumbers = v;
                        break;
                    case '15FA':
                        this.calendarTimeIncrement = v;
                        break;
                    case '15FB':
                        this.calendarWeatherEnabled = v;
                        break;
                    case '15FC':
                        this.calendarWeatherLocationBookmark = v;
                        break;
                    case '15FD':
                        this.calendarWeatherLocationsCollectionId = new HxObjectID_1.default(v);
                        break;
                    case '15FE':
                        this.calendarWeatherUnit = v;
                        break;
                    case '15FF':
                        this.calendarWeekStartDay = v;
                        break;
                    case '1600':
                        this.calendarWorkDays = v;
                        break;
                    case '1601':
                        this.calendarWorkingHoursEndTime = HxTimeSpan_1.deserializeHxTimeSpan(v);
                        break;
                    case '1602':
                        this.calendarWorkingHoursStartTime = HxTimeSpan_1.deserializeHxTimeSpan(v);
                        break;
                    case '1603':
                        this.calendarWorkingHoursTimeZone = v;
                        break;
                    case '1604':
                        this.isFocusedInboxClassifying = v;
                        break;
                    case '1605':
                        this.messageAfterMoveOrDeleteBehavior = v;
                        break;
                    case '1606':
                        this.messageAlwaysShowBcc = v;
                        break;
                    case '1607':
                        this.messageAlwaysShowFrom = v;
                        break;
                    case '1608':
                        this.messageAutoAddSignature = v;
                        break;
                    case '1609':
                        this.messageAutoAddSignatureOnMobile = v;
                        break;
                    case '160A':
                        this.messageAutoAddSignatureOnReply = v;
                        break;
                    case '160B':
                        this.messageCheckForForgottenAttachments = v;
                        break;
                    case '160C':
                        this.messageConversationSortOrder = v;
                        break;
                    case '160D':
                        this.messageDefaultFontColor = v;
                        break;
                    case '160E':
                        this.messageDefaultFontFlags = v;
                        break;
                    case '160F':
                        this.messageDefaultFontName = v;
                        break;
                    case '1610':
                        this.messageDefaultFontSize = v;
                        break;
                    case '1611':
                        this.messageDefaultFormat = v;
                        break;
                    case '1612':
                        this.messageEmailComposeMode = v;
                        break;
                    case '1613':
                        this.messageEmptyDeletedItemsOnLogoff = v;
                        break;
                    case '1614':
                        this.messageHideDeletedItems = v;
                        break;
                    case '1615':
                        this.messageLinkPreviewEnabled = v;
                        break;
                    case '1616':
                        this.messageNewItemNotification = v;
                        break;
                    case '1617':
                        this.messagePreviewMarkAsReadBehavior = v;
                        break;
                    case '1618':
                        this.messagePreviewMarkAsReadDelaytime = v;
                        break;
                    case '1619':
                        this.messageReadReceiptResponse = v;
                        break;
                    case '161A':
                        this.messageSendAddressDefault = v;
                        break;
                    case '161B':
                        this.messageShowConversationAsTree = v;
                        break;
                    case '161C':
                        this.messageSignatureHtml = v;
                        break;
                    case '161D':
                        this.messageSignatureText = v;
                        break;
                    case '161E':
                        this.messageSignatureTextOnMobile = v;
                        break;
                    case '161F':
                        this.messageUseDefaultSignatureOnMobile = v;
                        break;
                    case '1620':
                        this.onlineMeetingsByDefaultEnabled = v;
                        break;
                    case '1621':
                        this.regionalDataDateFormat = v;
                        break;
                    case '1622':
                        this.regionalDataTimeFormat = v;
                        break;
                    case '1623':
                        this.regionalDataTimeZone = v;
                        break;
                    case '1624':
                        this.speedyMeetingSettingId = new HxObjectID_1.default(v);
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxUserSettings.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObjectFromHandle(this.accountHandle, HxObjectType_1.default.HxAccount, sessionId).then(function (result) { return result; });
    };
    HxUserSettings.prototype.getCalendarLocalEventsLocation = function (sessionId) {
        return this.activeSet.getObject(this.calendarLocalEventsLocationId, sessionId).then(function (result) { return result; });
    };
    HxUserSettings.prototype.getCalendarWeatherLocationsCollection = function (sessionId) {
        return this.activeSet.getCollection(this.calendarWeatherLocationsCollectionId, sessionId);
    };
    HxUserSettings.prototype.getSpeedyMeetingSetting = function (sessionId) {
        return this.activeSet.getObject(this.speedyMeetingSettingId, sessionId).then(function (result) { return result; });
    };
    return HxUserSettings;
}(HxObject_1.default));
exports.HxUserSettings = HxUserSettings;
exports.default = HxUserSettings;
